import React, { useMemo, useState } from "react";
import { shuffle } from "../../data/sporeGames";

export const DecodeGame = ({ entry, onWin, onPenalty }) => {
  const answer = entry.symptom.toUpperCase();
  const letters = useMemo(() => answer.replace(/[^A-Z]/g, "").split(""), [answer]);
  const tiles = useMemo(() => {
    let t = shuffle(letters.map((ch, id) => ({ ch, id })));
    if (t.map((x) => x.ch).join("") === letters.join("")) t = t.reverse();
    return t;
  }, [letters]);
  const [used, setUsed] = useState([]);
  const [bad, setBad] = useState(null);
  const pos = used.length;

  const tap = (tile) => {
    if (used.includes(tile.id) || pos >= letters.length) return;
    if (tile.ch === letters[pos]) {
      const next = [...used, tile.id];
      setUsed(next);
      if (next.length === letters.length) onWin();
    } else {
      setBad(tile.id);
      setTimeout(() => setBad(null), 350);
      onPenalty(2);
    }
  };

  let li = 0;
  const slots = answer.split(" ").map((word, w) => (
    <span key={w} className="flex flex-nowrap gap-1 sm:gap-2">
      {word.split("").map((ch, i) => {
        if (!/[A-Z]/.test(ch)) return <span key={i} className="w-3 text-center text-slate-500 font-display text-2xl self-end">{ch}</span>;
        const filled = li < pos;
        li += 1;
        return (
          <span key={i} className={`w-7 h-10 sm:w-9 sm:h-12 flex items-center justify-center border-b-2 font-display text-xl sm:text-3xl font-bold ${filled ? "border-[#FF2E63] text-[#FF2E63]" : "border-slate-600 text-transparent"}`}>
            {filled ? ch : "_"}
          </span>
        );
      })}
    </span>
  ));

  return (
    <div className="space-y-8" data-testid="decode-game">
      <p className="border-l-2 border-rose-500/70 bg-rose-950/20 px-4 py-3 text-slate-200">
        <span className="font-tac text-xs text-rose-300 mr-3">INTERCEPT</span>
        {entry.clues[0]}
      </p>
      <div data-testid="decode-slots" className="flex flex-wrap justify-center gap-x-5 gap-y-3 sm:gap-x-8">{slots}</div>
      <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
        {tiles.map((tile) => {
          const isUsed = used.includes(tile.id);
          return (
            <button
              key={tile.id}
              type="button"
              data-testid={`decode-tile-${tile.id}`}
              data-letter={tile.ch}
              onClick={() => tap(tile)}
              disabled={isUsed}
              className={`w-11 h-11 sm:w-12 sm:h-12 rounded-sm border font-display text-xl font-bold transition-[opacity,transform,border-color] duration-200 active:scale-95 ${
                isUsed
                  ? "opacity-15 border-slate-800 text-slate-600"
                  : bad === tile.id
                  ? "border-red-500 text-red-400 bg-red-950/50 spore-shake"
                  : "border-slate-700 bg-slate-900 text-slate-100 hover:border-rose-400 hover:text-rose-200"
              }`}
            >
              {tile.ch}
            </button>
          );
        })}
      </div>
    </div>
  );
};
